module.exports = {"pathContext":{"name":"AlertInput","kind":"INPUT_OBJECT","type":"OBJECT","fields":[{"defaultValue":null,"description":null,"name":"color","type":{"kind":"SCALAR","name":"String","ofType":null}},{"defaultValue":null,"description":null,"name":"name","type":{"kind":"SCALAR","name":"String","ofType":null}}],"description":null,"enumValues":null,"possibleTypes":null}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/input-object-alert-input.json
// module id = 1343
// module chunks = 248379863452744